<template>
    <div>
        <div v-show="!showRejectionBlock" id="sumsub-websdk-container"></div>
        <div class="rejectionBlock" v-show="showRejectionBlock">
            <img src="assets/images/rejected.svg" />
            <h4>{{$t("verify.doc_message_one")}}</h4>
            <div>
                <router-link to="/open-tickets" class="btn btn-blue">{{$t("verify.view_ticket")}}</router-link>
            </div>
        </div>
    </div>
</template>
<script>
    import { useMainStore } from "@/store";
    import snsWebSdk from "@sumsub/websdk";
    export default {
        setup() {
            return { store: useMainStore() };
        },
        data() {
            return {
                ipvStarted: false,
                showRejectionBlock: false,
            };
        },
        prop: ["changeStep", "sumsubVerified"],
        methods: {
            startIpvNow() {
                let input_json = {};
                this.ipvStarted = !this.ipvStarted;
                this.store
                    .getIPVToken(input_json)
                    .then((response) => {
                        this.intializeSumSub(response);
                        if(this.store.user.profile.trulio_transaction_record_id){
                            try{
                                this.store.getTrullioDetails()
                            }catch(e){ console.log(e)}
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            },
            intializeSumSub({ accesstoken, levelname }) {
                console.log(accesstoken, "sub", levelname);
                this.launchWebSdk(
                    "https://api.sumsub.com", //"https://test-api.sumsub.com"
                    levelname,
                    accesstoken,
                    this.store.user.email,
                    "",
                    ""
                );
            },
            launchWebSdk(apiUrl, flowName, accessToken, applicantEmail, applicantPhone, customI18nMessages) {
                const _that = this;

                let snsWebSdkInstance = snsWebSdk
                    .init(accessToken, () => _that.store.sumSubToken.accesstoken)
                    .withBaseUrl("https://api.sumsub.com")
                    .withConf({
                        lang: "en", //language of WebSDK texts and comments (ISO 639-1 format)
                        email: applicantEmail,
                        phone: applicantPhone,
                        i18n: customI18nMessages, //JSON of custom SDK Translations
                        uiConf: {
                            customCssStr:
                                "button.submit:active:not(:disabled), button.submit:hover:not(:disabled):not(.disabled):not(:active), button[type=submit]:active:not(:disabled), button[type=submit]:hover:not(:disabled):not(.disabled):not(:active), #loader .round-icon, .round-icon{ background: #073763; color: #fff; background-image:none;}button.submit, button[type=submit]{ background: #073763; color: #fff;} .step.active .title, h3, h4, .content .desktop p, .document-status h2{color:#414649} .step.active .bullet:before, .step.active.success .bullet:before, .radio-item .checkmark:after{background-color:#073763} .mobile-button .fa-icon, .accent{color:#073763} .checkbox input:checked~.checkmark{background-color:#073763 ;border-color:#073763} .step.active .line, .step.success .line{background-color:#073763} .document-status p, p, .checkbox, .radio-item{color:#888da8;}",
                            // customCss: "https://url.com/styles.css"
                            // URL to css file in case you need change it dynamically from the code
                            // the similar setting at Customizations tab will rewrite customCss
                            // you may also use to pass string with plain styles `customCssStr:`
                        },
                    })
                    .withOptions({ addViewportTag: false, adaptIframeHeight: true })
                    // see below what kind of messages WebSDK generates
                    .on("idCheck.onApplicantSubmitted", (submitted) => {
                        console.log("submitted", submitted);
                        // console.log('stepCompleted', payload)
                        // setTimeout(function () {
                        //   _that.displayAvailableOption();
                        // }, 15000);
                    })
                    .on("idCheck.onApplicantResubmitted", (payload) => {
                        console.log("resubmitted", payload);
                        // setTimeout(function () {
                        //   _that.displayAvailableOption();
                        // }, 15000);
                        // if (messageType == "idCheck.applicantStatus") {
                        if ("reviewStatus" in payload && payload.reviewStatus == "completed") {
                            // _that.skipDocumentUpload()

                            if ("reviewResult" in payload && "reviewRejectType" in payload.reviewResult && payload.reviewResult.reviewRejectType == "RETRY") {
                                setTimeout(function () {
                                    _that.iframeVar = true;
                                    _that.showFeaturesDiv = false;
                                    _that.asktoallowNotification = false;
                                }, 15000);
                            } else {
                                _that.getSumSubResp();
                            }
                        } else if ("reviewStatus" in payload && payload.reviewStatus == "pending") {
                            // setTimeout(function () {
                            //   _that.displayAvailableOption();
                            // }, 15000);
                        } else {
                            console.log("sss");
                        }
                        // }
                    })
                    .on("idCheck.applicantStatus", (status) => {
                        console.log("status", status);
                        /*if(_that.store.user.profile.trulio_transaction_record_id){
                            try{
                                _that.store.getTrullioDetails()
                            }catch(e){ console.log(e)}
                        }*/
                        if (status.reviewResult && status.reviewResult.reviewAnswer == "GREEN") {
                            if(_that.store.user.profile.trulio_applicantId && !_that.store.user.profile.poa_status){
                                _that.showRejectionBlock = true;
                            }else{
                                _that.sumsubVerified();
                                _that.changeStep(4);
                            }
                        }
                        if (status.reviewResult && status.reviewResult.reviewAnswer && status.reviewResult.reviewAnswer == "RED" && status.reviewResult.reviewRejectType && status.reviewResult.reviewRejectType == "FINAL") {
                            _that.showRejectionBlock = true;
                        }
                        // if (
                        //   "reviewStatus" in payload &&
                        //   payload.reviewStatus == "completed"
                        // ) {
                        //   if (
                        //     "reviewResult" in payload &&
                        //     "reviewRejectType" in payload.reviewResult &&
                        //     payload.reviewResult.reviewRejectType == "RETRY"
                        //   ) {
                        //     setTimeout(function () {
                        //       _that.iframeVar = true;
                        //       _that.showFeaturesDiv = false;
                        //       _that.asktoallowNotification = false;
                        //     }, 15000);
                        //   } else {
                        //     _that.getSumSubResp();
                        //   }
                        // } else if (
                        //   "reviewStatus" in payload &&
                        //   payload.reviewStatus == "pending"
                        // ) {
                        //   setTimeout(function () {
                        //     _that.displayAvailableOption();
                        //   }, 15000);
                        // } else {
                        //   console.log("sss");
                        // }
                    })
                    .on("idCheck.onError", (error) => {
                        console.log("onError", error);
                    })
                    .build();
                // you are ready to go:
                // just launch the WebSDK by providing the container element for it
                snsWebSdkInstance.launch("#sumsub-websdk-container");
            },
        },
        created() {
            this.startIpvNow();
        },
    };
</script>
